export default __webpack_public_path__ + "static/media/duck-logo.77c7ee82.png";